import type { WarmupStep } from './types';

export function maxCapFromWarmup(steps: WarmupStep[]): number {
  return steps[steps.length - 1]?.emails ?? 0;
}

export function rampDaysFromWarmup(steps: WarmupStep[]): number {
  return steps[steps.length - 1]?.dayTo ?? 0;
}

/**
 * Semantic colors for the plan data-visualisation. These are not part of the
 * MUI theme palette (which only carries brand navy/orange), so they live here
 * and are reused across all plan components.
 */
export const PLAN_COLORS = {
  past: '#1d4ed8', // blue — past/lookback leads
  pastBg: '#eff6ff',
  newLeads: '#0d7a4e', // green — new unsold leads
  newBg: '#e8f8f1',
  newBatch: '#b45309', // amber — leads per steady batch
  amberBg: '#fef3c7',
  both: '#6d28d9', // purple — both sources running
  bothBg: '#f5f3ff',
  orange: '#e8560a', // primary accent (config / ramp)
  orangeBg: '#fff0e8',
  red: '#b91c1c',
  redBg: '#fee2e2',
  green: '#0d7a4e',
  greenBg: '#e8f8f1',
} as const;
